// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1c1c8fda","885":"17e141a9","977":"f2aecc70"}[chunkId] + ".chunk.js";
};